/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum InvestmentWorkflowStatus {
    OPEN = 'OPEN',
    DEFINITION_COMPLETE = 'DEFINITION_COMPLETE',
    IN_PROGRESS = 'IN_PROGRESS',
    COMPLETE = 'COMPLETE',
    RELEASED = 'RELEASED',
}
